var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiSearch = function SvgAiSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    style: {
      display: "block",
      height: "100%",
      width: "100%"
    },
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.264 10.964 12.38 8.08a4.525 4.525 0 1 0-1.14 1.14l2.885 2.885.002.002a.813.813 0 0 0 1.136 0l.002-.002a.806.806 0 0 0 0-1.14ZM5.78 5.514a2.897 2.897 0 1 1 5.795.001 2.897 2.897 0 0 1-5.795 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.357 7.753a.26.26 0 0 1 .254.209l.487 2.436 1.919.479a.26.26 0 0 1 0 .504l-1.919.48-.487 2.435a.26.26 0 0 1-.509 0l-.487-2.436-1.918-.48a.26.26 0 0 1 0-.503l1.918-.48.487-2.435a.26.26 0 0 1 .255-.209ZM6.473 12.427a.26.26 0 0 1 .246.178l.219.656.656.219a.26.26 0 0 1 0 .492l-.656.219-.219.656a.26.26 0 0 1-.492 0l-.22-.656-.655-.219a.26.26 0 0 1 0-.492l.656-.22.219-.655a.26.26 0 0 1 .246-.178Z"
  })));
};
export default SvgAiSearch;